import React from 'react';

interface ExclamationTriangleSVGAlternativeProps {
	class: string;
}

/**
 * Check SVG
 *
 * @returns
 */
function ExclamationTriangleSVGAlternative(props: ExclamationTriangleSVGAlternativeProps) {
	return (
		<svg
			viewBox="0 0 34 32"
			className={'icon icon-exclamation-triangle-2 ' + props.class}
			focusable="false"
			aria-hidden="true"
		>
			<path d="M33.877 27.322l-14.124-25.762c-0.499-0.935-1.468-1.56-2.583-1.56s-2.084 0.625-2.575 1.544l-0.008 0.016-14.178 25.762c-1.154 2.079 0.276 4.679 2.583 4.679h28.301c2.311 0 3.739-2.599 2.585-4.679zM15.521 10.86c-0.001-0.024-0.002-0.053-0.002-0.081 0-0.881 0.714-1.596 1.596-1.596s1.596 0.714 1.596 1.596c0 0.029-0.001 0.057-0.002 0.085l0-0.004v7.856c0.001 0.024 0.002 0.053 0.002 0.081 0 0.881-0.715 1.596-1.596 1.596s-1.596-0.715-1.596-1.596c0-0.029 0.001-0.057 0.002-0.085l-0 0.004zM17.17 27.206c-0.025 0.001-0.054 0.002-0.084 0.002-0.926 0-1.677-0.751-1.677-1.677s0.751-1.677 1.677-1.677c0.926 0 1.677 0.751 1.677 1.677 0 0 0 0 0 0v0c0 0.011 0 0.025 0 0.038 0 0.889-0.709 1.613-1.592 1.637l-0.002 0z" />
		</svg>
	);
}

// Set default props
ExclamationTriangleSVGAlternative.defaultProps = {
	class: '',
};

export default ExclamationTriangleSVGAlternative;
